import {useGuestGroup} from 'hooks';
import {useReservation} from 'context/reservation';
import {useSummary} from 'context/summary';
import {COUNTRY_CODES} from '@chekin/core';
import {getIsLeaderGuest} from 'utils/guestForm/utils';

export const useFirstGuestMustBeAdult = () => {
  const {guestGroup, isLoading: isLoadingGuestGroup} = useGuestGroup();
  const {housing, isLoading: isLoadingReservation} = useReservation();
  const {countryCode, isInstantCheckInEnabled} = useSummary();

  const hasNoGuests = guestGroup?.added_number_of_guests === 0;

  return {
    isLoading: isLoadingReservation || isLoadingGuestGroup,
    firstGuestMustBeAdult:
      hasNoGuests &&
      countryCode === COUNTRY_CODES.uae &&
      housing?.is_police_registration_enabled,
    guestMustBeAdult: isInstantCheckInEnabled && getIsLeaderGuest(),
  };
};
